import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

export const enum fields {
    title = "title",
    videoId = "videoId",
    videoProvider = "videoProvider",

    displayTitle = "Title",
    displayVideoId = "Video ID",
    displayVideoProvider = "Video service provider",
}

export interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.videoId]: string;
        [fields.videoProvider]: string;
    };
}

export const mapStateToProps = (_: ApplicationState, __: OwnProps) => {
    return {};
};

export type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface VideoCardWidgetStyles {
    wrapper?: InjectableCss;
    video?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
}

export const videoCardWidgetStyles: VideoCardWidgetStyles = {};

export const styles = videoCardWidgetStyles;

export const videoCardWidget = ({ fields: { title, videoId, videoProvider } }: Props) => {
    const youtubeLink = `${videoProvider}/${videoId}`;

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.video}>
                <iframe src={youtubeLink} frameBorder="0"></iframe>
            </StyledWrapper>
            {title && (
                <StyledWrapper {...styles.titleWrapper}>
                    <Typography {...styles.title}>{title}</Typography>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(videoCardWidget) as any,
    definition: {
        displayName: "Video Card",
        group: "Verndale Box" as any,
        icon: "presentation-screen",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: fields.displayTitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.videoId,
                displayName: fields.displayVideoId,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.videoProvider,
                displayName: fields.displayVideoProvider,
                editorTemplate: "DropDownField",
                defaultValue: "https://www.youtube.com/embed",
                options: [
                    {
                        displayName: "Youtube",
                        value: "https://www.youtube.com/embed",
                    },
                ],
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
